module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website_grid_ui-11df4c7ccc691180b9b7f5b455fc166f.webp";